/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AvatarSourceEnum } from './AvatarSourceEnum';
import {
    AvatarSourceEnumFromJSON,
    AvatarSourceEnumFromJSONTyped,
    AvatarSourceEnumToJSON,
} from './AvatarSourceEnum';
import type { ProjectVisibilityDTO } from './ProjectVisibilityDTO';
import {
    ProjectVisibilityDTOFromJSON,
    ProjectVisibilityDTOFromJSONTyped,
    ProjectVisibilityDTOToJSON,
} from './ProjectVisibilityDTO';

/**
 * 
 * @export
 * @interface NewProjectDTO
 */
export interface NewProjectDTO {
    /**
     * 
     * @type {string}
     * @memberof NewProjectDTO
     */
    organizationIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof NewProjectDTO
     */
    projectKey?: string;
    /**
     * 
     * @type {string}
     * @memberof NewProjectDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NewProjectDTO
     */
    displayClass?: string;
    /**
     * 
     * @type {string}
     * @memberof NewProjectDTO
     */
    description?: string;
    /**
     * 
     * @type {ProjectVisibilityDTO}
     * @memberof NewProjectDTO
     */
    visibility?: ProjectVisibilityDTO;
    /**
     * 
     * @type {number}
     * @memberof NewProjectDTO
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof NewProjectDTO
     */
    avatarUrl?: string;
    /**
     * 
     * @type {AvatarSourceEnum}
     * @memberof NewProjectDTO
     */
    avatarSource?: AvatarSourceEnum;
}



/**
 * Check if a given object implements the NewProjectDTO interface.
 */
export function instanceOfNewProjectDTO(value: object): value is NewProjectDTO {
    if (!('organizationIdentifier' in value) || value['organizationIdentifier'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function NewProjectDTOFromJSON(json: any): NewProjectDTO {
    return NewProjectDTOFromJSONTyped(json, false);
}

export function NewProjectDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewProjectDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationIdentifier': json['organizationIdentifier'],
        'projectKey': json['projectKey'] == null ? undefined : json['projectKey'],
        'name': json['name'],
        'displayClass': json['displayClass'] == null ? undefined : json['displayClass'],
        'description': json['description'] == null ? undefined : json['description'],
        'visibility': json['visibility'] == null ? undefined : ProjectVisibilityDTOFromJSON(json['visibility']),
        'version': json['version'] == null ? undefined : json['version'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'avatarSource': json['avatarSource'] == null ? undefined : AvatarSourceEnumFromJSON(json['avatarSource']),
    };
}

export function NewProjectDTOToJSON(value?: NewProjectDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organizationIdentifier': value['organizationIdentifier'],
        'projectKey': value['projectKey'],
        'name': value['name'],
        'displayClass': value['displayClass'],
        'description': value['description'],
        'visibility': ProjectVisibilityDTOToJSON(value['visibility']),
        'version': value['version'],
        'avatarUrl': value['avatarUrl'],
        'avatarSource': AvatarSourceEnumToJSON(value['avatarSource']),
    };
}

